import AbstractView from "abstracts/AbstractView";
import EmailCopy from "components/partials/email-copy/js/EmailCopy";


export default class FooterEmail extends AbstractView {
	constructor( $wrapper ) {
		super();
		
		this.$wrapper = $( $wrapper )
		this.$email   = this.$wrapper
		
		this.init();
	}
	
	
	initEl() {
		super.initEl();
		
		this.emailCopy = new EmailCopy( this.$wrapper, true );
	}
	
	
}
